let language = {
    STANDARD_ORDER_PAY_CONFIRM_TIP: "请确认您的设计和配送地址正确。订单一旦提交，将无法修改",
    SAMPLE_ORDER_PAY_CONFIRM_TIP: "请确认您的设计和配送地址正确。订单一旦提交，将无法修改"
}

export { language }